import { render, staticRenderFns } from "./adsourceItem.vue?vue&type=template&id=d121e562&scoped=true"
import script from "./adsourceItem.vue?vue&type=script&lang=js"
export * from "./adsourceItem.vue?vue&type=script&lang=js"
import style0 from "./adsourceItem.vue?vue&type=style&index=0&id=d121e562&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d121e562",
  null
  
)

export default component.exports